import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  Stack,
  Checkbox,
} from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import LoadingIndicator from '../../Global/loading-indicator/loading-indicator';
import { GetRiders } from '../../../api/proposals';
import Alert from '@mui/material/Alert';

const AGE_LIMIT = 65;
const STATE = 'CA';
const NAME = 'Death Benefit Enhancement Rider';

const RiderInfo = forwardRef((props, ref) => {
  const { data, versions, setRiderloading, client } = props;
  const state = client?.residentState;
  const age = client?.age;
  const [ridersInfo, setRidersInfo] = useState(new Map());
  const getRiderQuery = useMutation({
    mutationFn: () => GetRiders(`${data.productName}`)(),
  });
  const { isPending: isLoading, isError, isSuccess, data: ridersData } = getRiderQuery;

  useEffect(() => {
    const riders = (versions?.length > 0 && versions?.[0]?.illustrationData?.Riders) || [];
    const newRidersMap = new Map();
    riders?.length && riders.forEach((rider) => newRidersMap.set(rider.name, rider));
    setRidersInfo(newRidersMap);
    getRiderQuery.mutate();
  }, []);

  useEffect(() => {
    setRiderloading(!!getRiderQuery?.isPending);
  }, [getRiderQuery?.isPending]);

  const getClientInfo = () => {
    const currentVersion = data.createdVersions[0];
    currentVersion.illustrationData = {
      ...currentVersion.illustrationData,
      Riders: Array.from(ridersInfo.values()),
    };
    data.createdVersions = [currentVersion];
    return data;
  };
  const handleRiderChange = (object) => {
    const newRidersMap = new Map(ridersInfo);

    if (newRidersMap.get(object.name) !== undefined) {
      newRidersMap.delete(object.name);
    } else {
      newRidersMap.set(object.name, object);
    }
    setRidersInfo(newRidersMap);
  };

  useEffect(() => {
    if (state === STATE && age >= AGE_LIMIT && ridersData?.options?.length) {
      handleRiderChange(ridersData?.options?.find((rider) => rider.name === NAME));
    }
  }, [state, age, ridersData]);

  useImperativeHandle(ref, () => {
    return {
      getClientInfo: () => getClientInfo(),
    };
  }, [ridersInfo]);

  return (
    <Stack>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        {isLoading && <LoadingIndicator />}
      </Box>
      <Stack gap={1.5}>
        {ridersData?.options?.length > 0
          ? ridersData?.options?.map((rider, index) => {
              return (
                <Card sx={{ width: '100%' }} variant="outlined" key={`${rider?.name}-${index}`}>
                  <CardContent
                    sx={{ '&:last-child': { paddingBottom: '.5rem' }, padding: '.5rem 1rem' }}
                  >
                    <FormGroup>
                      <FormControlLabel
                        sx={{ margin: 0 }}
                        control={
                          <Checkbox
                            // value={ridersInfo.get(rider.name)}
                            disabled={state === STATE && age >= AGE_LIMIT && rider?.name === NAME}
                            name={rider?.name}
                            checked={ridersInfo.get(rider.name) !== undefined}
                            onChange={() => handleRiderChange(rider)}
                            color="primary"
                          />
                        }
                        label={`${rider?.name}`}
                      />
                    </FormGroup>
                  </CardContent>
                </Card>
              );
            })
          : !isLoading && <Alert severity="info">Riders not found.</Alert>}
      </Stack>
    </Stack>
  );
});
export default RiderInfo;
